import { DealPaymentsToSend } from 'src/hexagonal-architecture-frontend-base/src/domain/models/IPersona';

const parseAmount = (value: string | number): number => {
  if (typeof value === 'number') return value;
  if (!value) return 0;

  const stringValue = String(value).trim();
  if (stringValue.includes(',')) {
    return parseFloat(stringValue.replace(',', '.'));
  }
  return parseFloat(stringValue) || 0;
};

const getNextPaymentDate = (currentDate: Date, dayIndex: number): Date => {
  const date = new Date(currentDate);
  const currentDay = date.getDate();

  if (currentDay <= dayIndex) {
    const daysToAdd = dayIndex - currentDay;
    date.setDate(date.getDate() + daysToAdd);
  } else {
    const daysToSubtract = currentDay - dayIndex;
    date.setDate(date.getDate() - daysToSubtract);
    date.setMonth(date.getMonth() + 1);
  }
  return date;
};

export const createPaymentList = (numberOfPayments: number, dealId: string, paymentData: {
    onePaymentTotalAmount: number;
    installmentFirstPayment: number;
    installmentMonthlyPaymentAmount: number;
    installmentTotalAmount: number;
  },
  nameUser: string,
): DealPaymentsToSend[] => {
  const paymentsList: DealPaymentsToSend[] = [];
  let nextPaymentDate: Date | null = null;
  const currentDate = new Date();

  const onePaymentTotalAmount = parseAmount(paymentData.onePaymentTotalAmount);
  let installmentFirstPayment = parseAmount(paymentData.installmentFirstPayment);
  const installmentMonthlyPaymentAmount = parseAmount(paymentData.installmentMonthlyPaymentAmount);
  const installmentTotalAmount = parseAmount(paymentData.installmentTotalAmount);

  if (numberOfPayments === 1) {
    const paymentRow: DealPaymentsToSend = {
      M_todo_de_Pago: 'Recibo',
      Cobrado: '',
      Parent_Id: { id: dealId, name: '' },
      Observaciones: '',
      Pago: onePaymentTotalAmount.toFixed(2) as any,
      Fecha_Pago: getNextPaymentDate(currentDate, 13).toISOString().slice(0, 10) as any,
    };
    paymentsList.push(paymentRow);
  } else if (numberOfPayments === 2) {    
    for (let i = 0; i < numberOfPayments; i++) {
      const paymentRow: DealPaymentsToSend = {
        M_todo_de_Pago: 'Recibo',
        Cobrado: '',
        Parent_Id: { id: dealId, name: nameUser },
        Observaciones: '',
        Pago: installmentMonthlyPaymentAmount.toFixed(2) as any,
        Fecha_Pago: null as any,
      };

      if (nextPaymentDate === null) {
        paymentRow.Fecha_Pago = getNextPaymentDate(currentDate, 25)
          .toISOString()
          .slice(0, 10) as any;
        nextPaymentDate = getNextPaymentDate(currentDate, 25);
      } else {
        nextPaymentDate = new Date(nextPaymentDate);
        nextPaymentDate.setMonth(nextPaymentDate.getMonth() + 1);
        paymentRow.Fecha_Pago = nextPaymentDate.toISOString().slice(0, 10) as any;
      }

      paymentsList.push(paymentRow);
    }
  } else if (numberOfPayments > 2) {
    for (let i = 0; i < numberOfPayments; i++) {
      const paymentRow: DealPaymentsToSend = {
        M_todo_de_Pago: 'Recibo',
        Cobrado: '',
        Parent_Id: { id: dealId, name: nameUser },
        Observaciones: '',
        Pago: null as any,
        Fecha_Pago: null as any,
      };

      if (nextPaymentDate === null) {
        paymentRow.Fecha_Pago = getNextPaymentDate(currentDate, 25)
          .toISOString()
          .slice(0, 10) as any;
        nextPaymentDate = getNextPaymentDate(currentDate, 25);

        const calculateFirstPaymentTruncated = installmentTotalAmount / numberOfPayments;
        const calculateTotalInstallmentTruncated =
          (Math.trunc(calculateFirstPaymentTruncated * 100) / 100) * numberOfPayments;

        if (calculateTotalInstallmentTruncated !== installmentTotalAmount) {
          const difference = calculateTotalInstallmentTruncated - installmentTotalAmount;

          if (difference > 0) {
            installmentFirstPayment = installmentFirstPayment - difference;
          } else if (difference < 0) {
            installmentFirstPayment = installmentFirstPayment + difference;
          }
        }

        paymentRow.Pago = installmentFirstPayment.toFixed(2) as any;
      } else {
        nextPaymentDate = new Date(nextPaymentDate);
        nextPaymentDate.setMonth(nextPaymentDate.getMonth() + 1);
        paymentRow.Fecha_Pago = nextPaymentDate.toISOString().slice(0, 10) as any;
        paymentRow.Pago = installmentMonthlyPaymentAmount.toFixed(2) as any;
      }

      paymentsList.push(paymentRow);
    }
  }

  return paymentsList;
};

export const createPaymentListFromState = (
  numberOfPayments: number,
  dealId: string,
  totalAmount: number,
  firstPayment: number,
  totalAmountMonthly: number,
  financialCost: number,
  FEES = 38,
  nameUser: string,
): DealPaymentsToSend[] => {
  let installmentTotalAmount = totalAmount;
  const installmentFirstPayment = firstPayment;
  const installmentMonthlyPaymentAmount = totalAmountMonthly;

  if (numberOfPayments > 2) {
    installmentTotalAmount = totalAmount + financialCost + FEES;
  }

  return createPaymentList(
    numberOfPayments,
    dealId,
    {
      onePaymentTotalAmount: totalAmount,
      installmentFirstPayment,
      installmentMonthlyPaymentAmount,
      installmentTotalAmount,
    },
    nameUser,
  );
};
